import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';

const InspectionsHeading = (props) => {
    const [searchParams] = useSearchParams();
    const orgId = searchParams.get('org');
    const homeHref = orgId ? `/?org=${orgId}` : '/';
    return (
        <h1 className="header__inspections-h1">
            <Link to={homeHref}>Inspections</Link>
        </h1>
    );
}

export default InspectionsHeading;